<template>
<div class="flex flex-col max-w-prose">

  <!-- <p class="mt-4 text-xs text-gray-400 uppercase">
    Step 5 of 6
  </p> -->

  <label
    for="comments"
    class="flex flex-col justify-end text-xl text-gray-700 font-medium sm:text-2xl"
  >
    Please add more details about your requirements.
  </label>
  <p class="mt-2 text-sm text-gray-500">
    This might include:
  </p>
  <ul class="mt-1 pl-5 text-sm text-gray-500 list-disc list-outside space-y-1">
    <li>educational background</li>
    <li>strengths and weaknesses</li>
    <li>availability for tutoring sessions</li>
    <li>key dates or targets, e.g. date of exam</li>
    <li>any special educational needs</li>
  </ul>

  <textarea
    v-model="message"
    name="comments" 
    id="comments" 
    rows="6"
    class="comments mt-6 block w-full rounded-md border-gray-300 py-3 text-base placeholder-gray-400 shadow-sm focus:border-blue-500 focus:ring-blue-500"
    placeholder="e.g. I’m looking for someone to tutor my son once a week…"
  ></textarea>

  <p class="mt-2 text-xs text-gray-500">
    Please do not include any personally identifiable information as this may be shared with a multitude of tutors.
    In the next step, you will have an opportunity to provide contact details which are kept private.
  </p>

  <button type="button" @click="nextStep" class="mt-6 self-start inline-flex items-center gap-x-2.5 rounded-md bg-blue-600 px-3.5 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-blue-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-600">
    Next
    <svg class="-mr-0.5 h-4 w-4" xmlns="http://www.w3.org/2000/svg" height="16" width="16" viewBox="0 0 512 512">
      <path d="M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zM281 385c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l71-71L136 280c-13.3 0-24-10.7-24-24s10.7-24 24-24l182.1 0-71-71c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0L393 239c9.4 9.4 9.4 24.6 0 33.9L281 385z" fill="currentColor" />
    </svg>
  </button>

</div>
</template>
<script>
export default {
  props: {
    enquiry: Object,
  },
  data() {
    return {
      message: null
    }
  },
  methods: {
    nextStep() {
      this.$emit('updateEnquiry', { message: this.message })
      this.$router.push({ name: 'FindATutor-PersonalInfo' })
    }
  },
  mounted() {
    if (this.enquiry.message) this.message = this.enquiry.message
  }
}
</script>
<style lang="scss" scoped>

.comments::placeholder {
  font-size: 0.9em;
}

</style>